import React, { ReactNode, useContext, useEffect, useState } from "react";

import { PropertyAPIPromiseClient } from "../gen/witbooking/backoffice/property/v1/property_api_grpc_web_pb";
import { GetPropertyTickersRequest } from "../gen/witbooking/backoffice/property/v1/property_api_pb";
import { useGrpcClient, useUserGrpcCall } from "../lib/grpc";
import { LOCAL_STORAGE_KEYS } from "../modules/witadmin/Common/constants";

import { useKeycloak } from "./keycloak-provider";

const initialContext: string[] = [];
const UserContext = React.createContext(initialContext);

interface UserPropertyTickersProviderProps {
  children: ReactNode;
}

export function UserPropertyTickersProvider({ children }: UserPropertyTickersProviderProps) {
  const keycloak = useKeycloak();

  const propertyGrpcClient = useGrpcClient(PropertyAPIPromiseClient);
  const getPropertyTickers = useUserGrpcCall(
    propertyGrpcClient,
    propertyGrpcClient.getPropertyTickers
  );

  const [userPropertyTickers, setUserPropertyTickers] = useState<string[]>([]);

  useEffect(() => {
    const valueInLocalStorage = window.localStorage.getItem(LOCAL_STORAGE_KEYS.USER_TICKERS);

    async function loadUserPropertyTickers() {
      const propertyTickersList = (
        await getPropertyTickers(new GetPropertyTickersRequest())
      ).getPropertyTickersList();

      // only update property tickers if are distinct from local storage
      if (JSON.stringify(propertyTickersList) !== valueInLocalStorage) {
        window.localStorage.setItem(
          LOCAL_STORAGE_KEYS.USER_TICKERS,
          JSON.stringify(propertyTickersList)
        );
        setUserPropertyTickers(propertyTickersList);
      }
    }

    if (valueInLocalStorage) {
      setUserPropertyTickers(JSON.parse(valueInLocalStorage));
    }

    loadUserPropertyTickers().catch(err =>
      console.error("Error loading user propertyTickers", err)
    );
  }, [getPropertyTickers, keycloak]);

  return <UserContext.Provider value={userPropertyTickers}>{children}</UserContext.Provider>;
}

export default UserPropertyTickersProvider;

export function useUserPropertyTickers(): string[] {
  return useContext(UserContext);
}
